import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='container'>
        <p>
            For RO Repair in Dhanbad, Bokaro & Jamshedpur &amp; Home Visit Charge @299 Only. Best RO Repair Center in Dhanbad, Bokaro & Jamshedpur. Trained Technicians.
        </p>
      </div>
    </header>
  )
}
